import { configuration } from 'src/configuration';
import { CohortState, CohortStepData, CohortStepType } from 'src/types/cohorts';
import { patch, post } from 'src/utils/fetch';
import { to } from 'to-await';

const BASE_URL = `${configuration.accountApiUrl}/data-sources`;

export const createCohort = async ({
  dataSourceId,
  query,
}: {
  dataSourceId: string;
  query: string;
}) => {
  const [error, response] = await to(post(`${BASE_URL}/${dataSourceId}/cohort`, { query }));
  if (error) {
    throw error;
  }
  return response;
};

export const createCohortNextStep = async ({
  dataSourceId,
  cohortId,
  currentStep,
  steps,
  organizationId,
}: {
  dataSourceId: string;
  cohortId: string;
  currentStep: CohortStepType;
  steps: Record<CohortStepType, CohortStepData>;
  organizationId: string | null;
}) => {
  const [error, response] = await to(
    patch(`${BASE_URL}/${dataSourceId}/cohort/${cohortId}/next-step`, {
      currentStep,
      steps,
      organizationId,
    }),
  );
  if (error) {
    throw error;
  }
  return response;
};

export const createCohortEditStep = async ({
  dataSourceId,
  cohortId,
  step,
  editedContent,
}: {
  dataSourceId: string;
  cohortId: string;
  step: CohortStepType;
  editedContent: string;
}) => {
  const [error, response] = await to(
    patch(`${BASE_URL}/${dataSourceId}/cohort/${cohortId}/edit-step`, { step, editedContent }),
  );
  if (error) {
    throw error;
  }
  return response;
};

export const createCohortRunJob = async ({
  dataSourceId,
  cohortId,
  steps,
}: {
  dataSourceId: string;
  cohortId: string;
  steps: Record<CohortStepType, CohortStepData>;
}) => {
  const [error, response] = await to(
    patch(`${BASE_URL}/${dataSourceId}/cohort/${cohortId}/run-job`, { steps }),
  );
  if (error) {
    throw error;
  }
  return response;
};

export const updateCohortDetails = async ({
  dataSourceId,
  cohortId,
  data,
}: {
  dataSourceId: string;
  cohortId: string;
  data: Partial<CohortState>;
}) => {
  const [error, response] = await to(patch(`${BASE_URL}/${dataSourceId}/cohort/${cohortId}`, data));

  if (error) {
    throw error;
  }

  return response;
};

export const updateCohortSteps = async ({
  dataSourceId,
  cohortId,
  steps,
}: {
  dataSourceId: string;
  cohortId: string;
  steps: any;
}) => {
  const [error, response] = await to(
    patch(`${BASE_URL}/${dataSourceId}/cohort/${cohortId}/steps`, steps),
  );

  if (error) {
    throw error;
  }

  return response;
};
